import './CalendarOutlineIcon.css';
export var calendarIndicatorBackgroundCSS = '_2wdx0t2-2-0-1';
export var calendarIndicatorCSS = '_2wdx0t1-2-0-1';
export var calendarOutlineCSS = '_2wdx0t0-2-0-1';
export var calendarRangeCornersCSS = '_2wdx0t3-2-0-1';
export var calendarRangeCornorVisibleCSS = '_2wdx0t4-2-0-1';